import React, { useState } from "react";
import "./Questions.css";
import Title from "../Title/title";

function Questions() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqItems = [
    {
      question: "Я не знаю какой хочу цвет, боюсь темного",
      answer:
        "У нас огромная палитра оттенков! Поэтому мы подбираем идеальный для вашего образа оттенок, учитывая ваш цветотип, тон кожи и личные предпочтения. Перед процедурой делаем пробный макияж.",
    },
    {
      question: "Это очень больно?",
      answer:
        "Это совсем не больно! Используется американская первичная анестезия премиум-класса. Большинство клиентов спят на процедуре или чувствуют лишь легкое покалывание.",
    },
    {
      question: "Как проходит заживление? Я смогу выйти на улицу?",
      answer:
        "Никаких корок, только легкое шелушение от 2 до 10 дней в зависимости от зоны. Сразу после процедуры можно в ресторан или на встречу! Даем подробную инструкцию по уходу и крем для восстановления.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="content" id="Questions">
      <div className="heading">
        <Title title="Вопросы" translate="Questions" />
      </div>

      <div className="container-faq">
        <div className="faq-intro">
          <p className="faq-intro-text">
            Здесь собраны самые частые вопросы от наших клиентов. Если не нашли
            ответ на свой вопрос — свяжитесь со мной!
          </p>
        </div>

        {/* Аккордеон с вопросами */}
        <div className="befor-content">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className={`block-befor-content ${activeIndex === index ? "active" : ""}`}
            >
              <div
                className="question-header"
                onClick={() => toggleAccordion(index)}
              >
                <p className="p-questions">{item.question}</p>
                <div className="toggle-icon"></div>
              </div>

              <div className="answer-content">
                <p className="p-answers">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Блок контактов с Telegram кнопкой */}
        <div className="faq-contact">
          <h3 className="faq-contact-title">Остались вопросы?</h3>
          <p className="faq-contact-text">
            Не нашли ответ на свой вопрос? Напишите мне в Telegram — с радостью
            проконсультирую и помогу определиться с процедурой!
          </p>
          <a
            href="https://t.me/alena_brow1"
            target="_blank"
            rel="noopener noreferrer"
            className="telegram-button"
            onMouseOver={(e) => {
              e.target.style.transform = "translateY(-3px)";
              e.target.style.boxShadow = "0 12px 35px rgba(0, 136, 204, 0.4)";
              e.target.style.backgroundColor = "#0077b3";
            }}
            onMouseOut={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 8px 25px rgba(0, 136, 204, 0.3)";
              e.target.style.backgroundColor = "#0088cc";
            }}
          >
            Написать в Telegram
          </a>
        </div>
      </div>
    </div>
  );
}

export default Questions;
